import React from "react";

export default function Dashboardsettings () {
    return(
        <h1> Settings Page </h1>
    )
}